import React from 'react';
import PropTypes from 'prop-types';
import { Dialog, TextField } from "@vitalsource/vstui";
import Dispatcher from "../../dispatcher";

class RedeemCode extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      maxInputs: 10,
      redeemCodes: [
        {
          redeemCode: "",
          errorMessage: "",
          hasError: false,
          isValid: false,
        },
      ]
    };

    this._validateCode = this._validateCode.bind(this);
    this._codeError = this._codeError.bind(this);
    this._onChange = this._onChange.bind(this);
    this._redeemCodes = this._redeemCodes.bind(this);
    this._addMore = this._addMore.bind(this);
    this._renderRedeemCodeInputs = this._renderRedeemCodeInputs.bind(this);
    this._closeModal = this._closeModal.bind(this);
  }

  componentDidMount() {
    Fraction.Helpers.codeError = this._codeError;
    Fraction.Helpers.validateCode = this._validateCode;
  }

  _closeModal() {
    this.props.onClose 
      ? this.props.onClose() 
      : Dispatcher.emit(Dispatcher.CLOSE_MODAL);
  }

  _validateCode(index) {
    const { redeemCodes } = this.state;
    if (redeemCodes.length > index) {
      redeemCodes[index].isValid = true;
      this.setState({redeemCodes});
    }
  }

  _codeError(index, empty) {
    const { redeemCodes } = this.state;
    if (redeemCodes.length > index) {
      redeemCodes[index].hasError = true;
      if (empty) {
        redeemCodes[index].errorMessage = i18n.t('redeem.empty');
      } else {
        redeemCodes[index].errorMessage = i18n.t('redeem.error');
      }
      this.setState({redeemCodes});
    }
  }

  _onChange(e, index) {
    const { redeemCodes } = this.state;
    redeemCodes[index] = {
      redeemCode: $(e.currentTarget).val().trim(),
      hasError: false,
      errorMessage: false
    };
    this.setState({redeemCodes});
  }

  _redeemPromises(codes) {
    return codes.map((code, index, codes) => {
      return new Promise((resolve, reject) => {
        if (code.redeemCode && !code.isValid) {
          Jigsaw.User.redeemCode(code.redeemCode, function(response) {
            if (response.isSuccess()) {
              Fraction.Helpers.validateCode(index);
              resolve(response);
            } else if (response.data.code === 401) {
              Fraction.Helpers.signin();
              resolve("INVALID_CODE");
            } else {
              Fraction.Helpers.codeError(index);
              resolve("INVALID_CODE");
            }
          });
        } else if (code.isValid) {
          resolve("ALREADY_VALIDATED");
        } else {
          Fraction.Helpers.codeError(index, true);
          resolve("EMPTY");
        }
      });
    });
  }

  _redeemCodes(e) {
    e.preventDefault();
    const codes = this.state.redeemCodes;
    
    Fraction.Helpers.clearStoredBookList();
    const redeemPromises = this._redeemPromises(codes);

    Promise.all(redeemPromises).then(responses => {
      if (responses.some(response => typeof response === 'object')) {
        Fraction.Helpers.userUpdateLicense();
        const totalBooks = responses
                            .filter(response => typeof response === 'object')
                            .reduce((count, response) => count + response.data.books.length, 0);

        if (totalBooks > 1) {
          Fraction.Helpers.toast(i18n.t('redeem.multi-redeem', {count: totalBooks}));
        } else {
          const book = responses.filter(response => typeof response === 'object' && response.data.books.length)[0].data.books[0];
          Fraction.Helpers.toast(i18n.t('redeem.single-redeem', {title: book.title, url: ('/#/books/'+book.isbn+"/")}));
        }

        Fraction.Reporter.gaEvent("code-redeemed");
      }
      if (responses.every(response => response !== "INVALID_CODE") && !responses.every(response => response === "EMPTY")) {
        this._closeModal();
      }

      this.form.validate();
    });
  }

  _addMore(e, quantity=1) {
    e.preventDefault();
    const newRedeem = {
      redeemCode: "",
      errorMessage: "",
      hasError: false,
      isValid: false,
    };
    const numberOfInputs = this.state.redeemCodes.length;
    if (numberOfInputs < this.state.maxInputs) {
      if ((numberOfInputs + quantity) > this.state.maxInputs) {
        quantity = (this.state.maxInputs - numberOfInputs);
      }
      this.setState({
        redeemCodes: this.state.redeemCodes.concat(Array(quantity).fill(newRedeem)),
      });
    }
  }

  _renderRedeemCodeInputs() {
    return this.state.redeemCodes.map((code, index) => {
      let className = "";
      if (code.isValid) {
        className = "valid-code";
      }
      return (
        <div key={`redeem-code-entry-${index}`}>
          <TextField
            autoComplete="off"
            className={className}
            disabled={code.isValid}
            label={i18n.t('redeem.code')}
            labelHidden
            onChange={(e) => this._onChange(e, index)}
            placeholder={i18n.t('redeem.code')}
            type="text"
            validate={() => {
              return new Promise((resolve) => {
                resolve(code.errorMessage);
              });
            }}
            value={code.redeemCode}
          />
      </div>
      );
    });
  }

  render() {
    return (
      <Dialog
        formProps={{
          innerRef: (x) => this.form = x,
          onSubmit: this._redeemCodes
        }}
        open
        primaryActionButton={{
          label: i18n.t('redeem.redeem')
        }}
        secondaryActionButton={{
          label: i18n.t('base.cancel'),
          onClick: this._closeModal,
        }}
        onRequestClose={this._closeModal}
        size="small"
        rootSelector="#bookshelf"
        title={i18n.t('redeem.redeem-code')}
      >
        <div className="redeem-code">
          <div id="redeem-code-list">
            {this._renderRedeemCodeInputs()}
          </div>
          {this.state.redeemCodes.length < this.state.maxInputs &&
            <div className="add-more">
              <a href="#" onClick={this._addMore}>
                {this.state.redeemCodes.length > 1 ? i18n.t('redeem.add-more') : i18n.t('redeem.add-multiple-codes')}
              </a>
            </div>
          }
          <p htmlFor="redeemCode">{i18n.t('redeem.redeem-description')}</p>
        </div>
      </Dialog>
    );
  }
}

RedeemCode.propTypes = {
  redeemFunction: PropTypes.func,
};

export default RedeemCode;
